// Per spec §3.5 + Spike 2 footgun #1: tool outputs come over the wire as
// json.dumps strings; some chat-only tools return dicts directly. Cards must
// handle both shapes via this single helper.

export type ToolOutput = Record<string, unknown> | null

export function parseToolOutput(raw: unknown): ToolOutput {
  if (raw === null || raw === undefined) return null
  if (typeof raw === 'object') return raw as ToolOutput
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as ToolOutput
    } catch {
      return { _parse_error: true, _raw: raw }
    }
  }
  return null
}
